import { useQueryClient, useMutation } from "@tanstack/react-query";
import api from "@/lib/api-client";
import { toast } from "react-toastify";

const updateAvailability = async ({ data, days }) => {
    const payload = {
        slots: days.flatMap((day) => {
            const dayData = data[day];
            const enabled = dayData?.enabled;
            const times = dayData?.Times ?? [];

            if (!enabled) {
                return [
                    {
                        availabilityGuid: times[0]?.availabilityGuid || null,
                        dayOfWeek: day,
                        startTime: null,
                        endTime: null,
                    },
                ];
            }

            return times.map((slot) => ({
                availabilityGuid: slot.availabilityGuid || null,
                dayOfWeek: day,
                startTime: slot.startTime || null,
                endTime: slot.endTime || null,
            }));
        }),
    };

    const res = await api.post(`/Clinician/Availability`, payload);

    return res.data;
};

export const useUpdateAvailability = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateAvailability,
        retry: 1,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["availability"],
            });
            toast.success("Schedule updated");
        },
        onError: () => {
            toast.error("Error updating schedule");
        },
    });
};
